import { render, staticRenderFns } from "./pile-info.vue?vue&type=template&id=6187be26&"
import script from "./pile-info.vue?vue&type=script&lang=ts&"
export * from "./pile-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports